import type { SharedEnvironment } from "@ucchub/ui";

export default function baseEnv(baseApi: string, legacyBaseApi: string) {
  return {
    portalUrl: "https://hub.ucc-dev.vodafone.com",
    baseApi,
    legacyBaseApi,
    api: {
      auth: `${baseApi}/authentication`,
      role: `${baseApi}/role`,
      navbar: `${baseApi}/role/nav-bar`,
      manageAccessTabs: `${baseApi}/role/permissions/ATTR-17fffb6c-fb6c-ffb6cdd30.-.432`,
    },
    legacyApi: {
      addresses: `${legacyBaseApi}/numberadministration-uchub/dev/addresses`,
      audioAnnouncements: `${legacyBaseApi}/callroutingconfig-uchub/dev/audio-announcements`,
      availableNumbers: `${legacyBaseApi}/numberpurchase-uchub/dev/availableNumbers`,
      storageAccessUrl: `${legacyBaseApi}/storageaccess-uchub/dev/getFileUrl`,
      destinationNumbers: `${legacyBaseApi}/numberadministration-uchub/dev/destinationNumbers`,
      businessGroups: `${legacyBaseApi}/organisationportaladmin-uchub/dev/organisation`,
      portalAnnouncements: `${legacyBaseApi}/vodafoneportaladmin-uchub/dev/portalAnnouncements`,
      regulatoryAnnouncements: `${legacyBaseApi}/numberadministration-uchub/dev/twilio-regulations/notifications`,
      callReports: `${legacyBaseApi}/callaudit-uchub/dev/callReports`,
      customerSettings: `${legacyBaseApi}/organisationportaladmin-uchub/dev/organisation`,
      callFlow: `${legacyBaseApi}/callroutingconfig-uchub/dev/callflow`,
      callFlowElements: `${legacyBaseApi}/callroutingconfig-uchub/dev/callflow-elements?active=true`,
      queueStats: `${legacyBaseApi}/reporting-uchub/dev/queueStatsWallboard?orgId=`,
      countryGroups: `${legacyBaseApi}/numberadministration-uchub/dev/countryGroups`,
      organisations: `${legacyBaseApi}/organisationportaladmin-uchub/dev/organisation`,
      productName: `${legacyBaseApi}/numberadministration-uchub/dev/product-name`,
      variable: `${legacyBaseApi}/callroutingconfig-uchub/dev/variable`,
      callflowMetadata: `${legacyBaseApi}/callroutingconfig-uchub/dev/callflow-metadata`,
      callflowList: `${legacyBaseApi}/callroutingconfig-uchub/dev/callflowlist`,
      callflow: `${legacyBaseApi}/callroutingconfig-uchub/dev/callflow`,
      queueStatsApiKey: "3AKj5W6DgKLb59TSuvWtNeynXgRSn5qNxYKX4d5k",
      callFlowItemTabs: `${baseApi}/role/permissions/iv-call-flow-items`,
      inboundNumbers: `${legacyBaseApi}/organisationportaladmin-uchub/dev/organisation/[orgId]/inboundnumber`,
      numberAdministration: `${legacyBaseApi}/numberadministration-uchub/dev/inboundNumbers`,
      numberPricing: `${legacyBaseApi}/numberpricing-uchub/dev/mrc`,
      inboundNumberWebhookUpdate: `${legacyBaseApi}/numberpurchase-uchub/dev/inboundNumberWebhookUpdate`,
      offlineNumberRequest: `${legacyBaseApi}/numberpurchase-uchub/dev/numberRequest`,
      callflowListBase: `${legacyBaseApi}/callroutingconfig-uchub/dev`,
      deliveryGroups: `${legacyBaseApi}/callroutingconfig-uchub/dev/delivery-groups`,
      purchaseNumbers: `${legacyBaseApi}/numberpurchase-uchub/dev/purchaseNumbers`,
      regulations: `${legacyBaseApi}/numberadministration-uchub/dev/twilio-regulations`,
      numberProvision: `${legacyBaseApi}/numberprovision-uchub/dev/numberprovision`,
      callLogs: `${legacyBaseApi}/callaudit-uchub/dev/callLogs`,
      queue: `${legacyBaseApi}/callroutingconfig-uchub/dev/queue`,
      destinationCountries: `${legacyBaseApi}/vodafoneportaladmin-uchub/dev/destinationCountries`,
      callAudit: `${legacyBaseApi}/callaudit-uchub/dev`,
      globalConfiguration: `${legacyBaseApi}/callroutingconfig-uchub/dev/settings`,
      sipTrunk: `${legacyBaseApi}/numberadministration-uchub/dev/siptrunks`,
      externalBillingNotification: `${legacyBaseApi}/numberprovision-uchub/dev/numberprovision/externalbilling`,
    },
    isProduction: (() => false)(),
    isDevelopment: (() => true)(),
    isStaging: (() => false)(),
  } satisfies SharedEnvironment;
}

export type Environment = ReturnType<typeof baseEnv>;
